import { createContext } from "react";
import { MappedEvent, ResultsFormattedTournament } from "@data-types/results";

export const ResultsTournamentContextMobile = createContext(
	{} as ResultsFormattedTournament<MappedEvent[]>
);
